import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.css';

export type BreadcrumbSegment = { label: string; to?: string };

export function Breadcrumb({ segments }: { segments: BreadcrumbSegment[] }) {
  if (segments.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" className={styles.bar}>
      <ol className={styles.list}>
        {segments.map((s, i) => (
          <li key={i} className={styles.item}>
            {i > 0 && <span aria-hidden className={styles.sep}>›</span>}
            {s.to ? <Link to={s.to}>{s.label}</Link> : <span>{s.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
